const feedbackStyles = {
  portal: {
    success:
      "rounded-lg border border-emerald-200/40 bg-emerald-400/15 px-4 py-3 text-center text-sm font-semibold text-emerald-700 shadow-lg backdrop-blur-sm",
    error:
      "rounded-lg border border-red-200/40 bg-red-500/15 px-4 py-3 text-center text-sm font-semibold text-red-700 shadow-lg backdrop-blur-sm",
  },
  dark: {
    success:
      "rounded-lg border border-emerald-200/40 bg-emerald-400/15 px-4 py-3 text-center text-sm font-semibold text-white shadow-lg backdrop-blur-sm",
    error:
      "rounded-lg border border-red-200/40 bg-red-500/15 px-4 py-3 text-center text-sm font-semibold text-white shadow-lg backdrop-blur-sm",
  },
};

export default function PortalFeedback({ type = "success", variant = "portal", children, className = "" }) {
  const styles = feedbackStyles[variant] || feedbackStyles.portal;

  return (
    <div className={`${styles[type] || styles.success} ${className}`}>
      {children}
    </div>
  );
}
